// Generated file - do not change manually!

/**
 * Different types of AvatarShape.
 */
export enum AvatarShape {
  /**
   * Circular shape.
   */
  Circle = 'Circle',

  /**
   * Square shape.
   */
  Square = 'Square'
}
